export default __webpack_public_path__ + "static/media/wx-pay-hover.7563cc87.svg";